import { ENTITY_DISPLAY_FORMATS, formatEntityLabel, } from '../../display/entityLabelFormat.js';
/**
 * Entities whose human label is not `description` (or whose default display
 * format would fall through to `id`). Join present parts with " - ".
 */
const AUDIT_LABEL_FIELDS = {
    Party: ['code', 'displayName'],
    DistributionCenter: ['name'],
    // Orders/NF-e have no `description`; partner is an FK — label is the business key.
    SalesOrder: ['code'],
    PurchaseOrder: ['code'],
    Invoice: ['number', 'series'],
    ProductionOrder: ['code'],
    ProfileData: ['abbreviation', 'name'],
    // Org-user has no display name on the record — console enriches via UserNameText.
    OrganizationUserOrgData: ['id'],
    SavedSelection: ['name'],
};
function labelFromFields(record, fields) {
    const parts = fields
        .map((field) => {
        const raw = record[field];
        if (raw == null || raw === '')
            return undefined;
        return String(raw);
    })
        .filter((part) => !!part);
    return parts.length > 0 ? parts.join(' - ') : undefined;
}
/**
 * Readable label of the aggregate root at write time (spec 0046 §10.3 / request 0252).
 * Uses the entity's default display format — not the org's console preference (log is domain).
 */
export function auditAggregateLabel(entity, record) {
    const customFields = AUDIT_LABEL_FIELDS[entity];
    if (customFields) {
        return labelFromFields(record, customFields) ?? String(record.id ?? '');
    }
    return formatEntityLabel(entity, record, ENTITY_DISPLAY_FORMATS[entity]?.default);
}
//# sourceMappingURL=auditAggregateLabel.js.map